export default __webpack_public_path__ + "static/media/newGame.0f44186d.mp3";